import { Center, Loader } from '@mantine/core';

interface LoadingProps {
  fullScreen?: boolean;
}

/**
 * Loading spinner component
 */
export function Loading({ fullScreen = true }: LoadingProps): JSX.Element {
  if (fullScreen) {
    return (
      <Center h="100vh" w="100%">
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <Center p="xl">
      <Loader size="md" />
    </Center>
  );
}
